import { render } from "./MessageView.vue?vue&type=template&id=3e82b38b&scoped=true&ts=true"
import script from "./MessageView.vue?vue&type=script&lang=ts"
export * from "./MessageView.vue?vue&type=script&lang=ts"

import "./MessageView.vue?vue&type=style&index=0&id=3e82b38b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.0_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e82b38b"]])

export default __exports__